"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentionCommit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var kangYang_1 = require("../../model/kangYang");
var service_1 = require("../../../library/base/service");
var IntentionCommit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IntentionCommit, _super);
    function IntentionCommit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '意向提交';
        _this.code = '101150';
        _this.desc = '意向提交';
        _this.requestParams = new kangYang_1.IntentionCommitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IntentionCommit;
}(service_1.BaseService));
exports.IntentionCommit = IntentionCommit;
//# sourceMappingURL=intentionCommit.js.map